module.exports = __webpack_public_path__ + "static/media/VN.2cfdcc06.svg";